// todo: перенести в пакет с утилитами и покрыть тестами

export function equals(array1: number[], array2: number[]): boolean;
export function equals(array1: string[], array2: string[]): boolean;
export function equals(array1: symbol[], array2: symbol[]): boolean;
export function equals(array1: boolean[], array2: boolean[]): boolean;
export function equals(array1: RegExp[], array2: RegExp[]): boolean;
export function equals(array1: Date[], array2: Date[]): boolean;
export function equals(array1: Record<string, unknown>[], array2: Record<string, unknown>[]): boolean;
export function equals(regExp1: RegExp, regExp2: RegExp): boolean;
export function equals(date1: Date, date2: Date): boolean;
export function equals(object1: string, object2: string): boolean;
export function equals(object1: number, object2: number): boolean;
export function equals(object1: symbol, object2: symbol): boolean;
export function equals(object1: boolean, object2: boolean): boolean;
export function equals<T = number>(object1: T, object2: T): boolean;
export function equals(object1: Record<string, unknown>, object2: Record<string, unknown>, field?: string): boolean;
export function equals<T = number>(object1: Record<string, T>, object2: Record<string, T>, field?: string): boolean;
/** @description Проверяет равны ли входящие параметры */
export function equals<T = number>(object1: T | Record<string, T>, object2: T | Record<string, T>, field?: string): boolean {
  if (field) {
    const object1Value = getNestedObjectValue<T>(object1 as Record<string, T>, field);
    const object2Value = getNestedObjectValue<T>(object2 as Record<string, T>, field);

    return (object1Value === object2Value);
  } else {
    return equalsByValue(object1, object2);
  }
}

export function equalsByValue(array1: number[], array2: number[]): boolean;
export function equalsByValue(array1: string[], array2: string[]): boolean;
export function equalsByValue(array1: symbol[], array2: symbol[]): boolean;
export function equalsByValue(array1: boolean[], array2: boolean[]): boolean;
export function equalsByValue(array1: RegExp[], array2: RegExp[]): boolean;
export function equalsByValue(array1: Date[], array2: Date[]): boolean;
export function equalsByValue(array1: Record<string, unknown>[], array2: Record<string, unknown>[]): boolean;
export function equalsByValue(regExp1: RegExp, regExp2: RegExp): boolean;
export function equalsByValue(date1: Date, date2: Date): boolean;
export function equalsByValue(object1: Record<string, unknown>, object2: Record<string, unknown>): boolean;
export function equalsByValue(object1: string, object2: string): boolean;
export function equalsByValue(object1: number, object2: number): boolean;
export function equalsByValue(object1: symbol, object2: symbol): boolean;
export function equalsByValue(object1: boolean, object2: boolean): boolean;
export function equalsByValue<T>(object1: T, object2: T): boolean;
/** @description Сравнивает параметры по значению */
export function equalsByValue(
  object1: string | number | symbol | boolean | RegExp | Date | unknown[] | Record<string, unknown>,
  object2: string | number | symbol | boolean | RegExp | Date | unknown[] | Record<string, unknown>,
): boolean {
  if (object1 === object2) {
    return true;
  }

  if (object1 && object2 && typeof object1 == 'object' && typeof object2 == 'object') {
    const object1IsArray = Array.isArray(object1);
    const object2IsArray = Array.isArray(object2);

    if (object1IsArray !== object2IsArray) {
      return false;
    }
    if (object1IsArray && object2IsArray) {
      return gasArrayEquals(object1 as Array<unknown>, object2 as Array<unknown>);
    }

    const object1IsDate = object1 instanceof Date;
    const object2IsDate = object2 instanceof Date;

    if (object1IsDate !== object2IsDate) {
      return false;
    }
    if (object1IsDate && object2IsDate) {
      return gasDateEquals(object1 as Date, object2 as Date);
    }

    const object1IsRegExp = object1 instanceof RegExp;
    const object2IsRegExp = object2 instanceof RegExp;

    if (object1IsRegExp !== object2IsRegExp) {
      return false;
    }
    if (object1IsRegExp && object2IsRegExp) {
      return gasRegExpEquals(object1 as RegExp, object2 as RegExp);
    }

    const keys = Object.keys(object1);
    const length = keys.length;
    let key: string;
    let i: number;

    if (length !== Object.keys(object2).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(object2, keys[i])) {
        return false;
      }
    }

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equalsByValue(object1[key], object2[key])) {
        return false;
      }
    }

    return true;
  }

  return object1 !== object1 && object2 !== object2;
}

/** @description Находит значение в объекте по ключу (поддерживает вложенный формат с точкой) */
export function getNestedObjectValue<T = string>(data: Record<string, T>, field: string): T {
  if (data && field) {
    if (field.indexOf('.') === -1) {
      return data[field];
    } else {
      const fields: string[] = field.split('.');
      let value: unknown = data;
      for (let i = 0, len = fields.length; i < len; ++i) {
        if (value === null) {
          return null;
        }
        value = value[fields[i]];
      }
      return value as T;
    }
  }
}

/** @description Проверяет является ли переданный элемент функцией */
export function isFunction(obj: any): boolean {
  return !!(obj && obj.constructor && obj.call && obj.apply);
}

function gasArrayEquals(array1: Array<unknown>, array2: Array<unknown>): boolean {
  const length = array1.length;
  if (length !== array2.length) {
    return false;
  }
  for (let i = length; i-- !== 0;) {
    if (!equalsByValue(array1[i], array2[i])) {
      return false;
    }
  }
  return true;
}

function gasDateEquals(date1: Date, date2: Date): boolean {
  return date1.getTime() === date2.getTime();
}

function gasRegExpEquals(regExp1: RegExp, regExp2: RegExp): boolean {
  return regExp1.toString() === regExp2.toString();
}

export const toCamelCase = (value: string): string =>
  value.match(/(\_\w)/)
    ? value.toLowerCase().replace(/(\_\w)/g, k => k[1].toUpperCase()).trim() : value;

export const camelCaseToKebab = (value: string): string => separateCamelCaseWithSymbol(value, '-');

export const camelCaseToSnake = (value: string): string => separateCamelCaseWithSymbol(value, '_');

export const separateCamelCaseWithSymbol = (value: string, char: string): string =>
  !value ? '' : value.replace(/([A-Z])/g, (g) => char + g[0].toLowerCase());
